import { listTippableStaff as publicListTippableStaff } from './tips-staff-v1-staff-tippable-staff.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const listTippableStaff: MaybeContext<
  BuildRESTFunction<typeof publicListTippableStaff> &
    typeof publicListTippableStaff
> = /*#__PURE__*/ createRESTModule(publicListTippableStaff);

export { IdentityType } from './tips-staff-v1-staff-tippable-staff.universal.js';
export {
  Staff,
  IdentificationData,
  IdentificationDataIdOneOf,
  ListTippableStaffRequest,
  ListTippableStaffResponse,
  ListTippableStaffResponseNonNullableFields,
  ListTippableStaffOptions,
} from './tips-staff-v1-staff-tippable-staff.universal.js';
